import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';

import { Typography } from '@welovedevs/ui';

import { styles } from './no_language_styles';
import { NoDataButton } from '../../../../../commons/no_data_button/no_data_button';

const useStyles = makeStyles(styles);

const NoLanguageComponent = ({ handleAddButtonClick }) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <Typography style={{ color: 'inherit' }} variant="h4" component="h4">
                <FormattedMessage
                    id="Languages.noLanguage.title"
                    defaultMessage="Les langues que vous maîtrisez seront affichées avec votre niveau ."
                />
            </Typography>
            <NoDataButton
                handleAddButtonClick={handleAddButtonClick}
                classes={{
                    container: classes.button
                }}
            >
                <FormattedMessage id="Languages.noLanguage.buttonLabel" defaultMessage="Ajouter une langue" />
            </NoDataButton>
        </div>
    );
};

export const NoLanguage = NoLanguageComponent;
